import '../../../rich-content/components/rich-content-editor/rich-content-editor.global.scss';
import './app-root.scss';

import React from 'react';
import {
  ImgProvider,
  RENDER_IMAGE,
  RENDER_IMAGE_WITH_PLACEHOLDER_INITIALLY,
} from '@wix/communities-image-lib';
import { I18nextProvider } from '@wix/yoshi-flow-editor';

import BlogPushNotifications from '../../../common/components/blog-push-notifications';
import { FastFormProvider } from '../../../common/components/fast-form';
import { getFastFormSubmitAction } from '../../../common/components/fast-form/store/fast-form-selectors';
import PermissionsProvider from '../../../common/components/permissions-provider';
import ResponsiveListener from '../../../common/components/responsive-listener/responsive-listener';
import { withRootProps } from '../../../common/components/root-props/with-root-props';
import { connect } from '../../../common/components/runtime-context';
import { withReduxStore } from '../../../common/components/runtime-context/with-redux-store';
import WindowResizeListener from '../../../common/components/window-resize-listener';
import {
  getPinterestEnabled,
  getIsCreatedWithResponsiveEditor,
} from '../../../common/selectors/app-settings-selectors';
import { initI18n } from '../../../common/services/init-i18n';
import { isWebpSupported } from '../../../common/services/is-webp-supported';
import pinterest from '../../../common/services/pinterest';
import {
  getLanguage,
  isSeo,
  getIsMobile,
  isEditor,
} from '../../../common/store/basic-params/basic-params-selectors';
import { getTranslations } from '../../../common/store/translations/translations-selectors';
import PostPushNotifications from '../../components/post-push-notifications';
import Router from '../router';

class AppRoot extends React.Component {
  constructor(props) {
    super(props);
    const { language, isMobile, isPinterestEnabled } = this.props;
    pinterest.init({ language, isMobile, isPinterestEnabled });
  }

  componentWillUnmount() {
    pinterest.removeEventListener();
  }

  getI18nConfig = () => {
    const { language, translations } = this.props;

    if (this.lastLanguage !== language) {
      this.i18nConfig = initI18n(language, translations);
      this.lastLanguage = language;
    }
    return this.i18nConfig;
  };

  render() {
    const { addResizeListener, submitAction, isSeo } = this.props;
    const i18n = this.getI18nConfig();

    return (
      <ResponsiveListener>
        <PermissionsProvider>
          <I18nextProvider i18n={i18n}>
            <ImgProvider
              renderMode={
                isSeo ? RENDER_IMAGE : RENDER_IMAGE_WITH_PLACEHOLDER_INITIALLY
              }
              {...(isWebpSupported() ? { format: 'webp' } : {})}
            >
              <FastFormProvider
                submitAction={submitAction}
                // onSubmit={actions.fastFormSubmitCallback} // unused currently, when used need to tranform contentState
              >
                <Router />
                {addResizeListener && <WindowResizeListener />}
                <BlogPushNotifications />
                <PostPushNotifications />
              </FastFormProvider>
            </ImgProvider>
          </I18nextProvider>
        </PermissionsProvider>
      </ResponsiveListener>
    );
  }
}

const mapRuntimeToProps = (state) => {
  const isInClassicEditor =
    isEditor(state) && !getIsCreatedWithResponsiveEditor(state);
  return {
    language: getLanguage(state),
    translations: getTranslations(state),
    isSeo: isSeo(state),
    isMobile: getIsMobile(state),
    isPinterestEnabled: getPinterestEnabled(state),
    submitAction: getFastFormSubmitAction(state),
    addResizeListener: isInClassicEditor,
  };
};

export default withRootProps(
  withReduxStore(connect(mapRuntimeToProps)(AppRoot)),
);
